import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  cargoItem : yup.string().required('Cargo item is required'),
  cargoType: yup.string().required('Cargo type is required'),
    volume: yup.string().required('Volume is required'),
    weight: yup.string().required('Weight is required'),
    count : yup.string().required('Count is required'),
    packageType: yup.string().required('Package type is required'),
});

